export default "/build/images/telegram.png?3e10b18c5ce7154805b08be69b9c40d4";